import React from 'react'
import ProfileViews from './../../components/ProfileViews'
import ReturnHeader from './../../components/returnHeader'
import { logout, pen,  } from '../../assets'
import { Link } from 'react-router-dom'

const index = () => {
  const content = [
    {
      icon: pen,
      text: 'Edit'
    },
    {
      icon: logout,
      text: 'Logout',
      path: '/language'
    },
  ]
  return (
    <>
    <ReturnHeader name={'@IUraimov12'}>
    {content &&
            content.map((item)=>(
              <Link to={item.path}
              className="flex hover:bg-slate-100 cursor-pointer h-[26px] sm:h-[30px] justify-start gap-5 items-center	p-1.5	md:p-3"
              >
            <div><img className="w-[12px] h-[12px]" src={item.icon} alt="" /></div>
            <div className="text-[13px] md:text-[16px]">{item.text}</div>
          </Link>
            ))}
    </ReturnHeader>
    <ProfileViews 
    // Follower={'10000'} 
    // Following={'1k'} 
    // Lessons={'1k'} 
    // profession={'Teacher'} 
    // name={'Ibrohim IUraimov'}
    // info={"Lorem ipsum"}
    secondBtnLink={'/portfolio'}
    Telegram={'https://web.telegram.org'}
    Instagram={'https://instagram.com'}
    Facebook={'https://facebook.com'}
    btnBackground={'bg-blue-buttonBlue shadow-blueShadow'}
    thirdBtnLink={'/message'}
    style={'text-white'}
    blue={true}
    firstBtn={'Follow'}
    secondBtn={'Portfolio'}
    thirdBtn={'Message'}
    />
    </>
  )
}

export default index